import { takeLatest, call, put, all } from 'redux-saga/effects';

import { 
  fetchHotfundSuccess,
  fetchHotfundFailure,
} from '../_actions/hotfund.actions';
import { hotfundConstants } from '../_constants/hotfund.constants';

import {
  fetchHotfundByTopBottom,
  fetchHotfundAll,
} from '../_services/hotfund.services';

export function* fetchHotfundAsync({ payload }) {
  try {
    if (payload && payload.viewType === 'ALL') {
      const resultAll = yield call(fetchHotfundAll, payload);
      yield put(fetchHotfundSuccess(resultAll.data));
    } else {
      const resultTopBottom = yield call(fetchHotfundByTopBottom, payload);
      yield put(fetchHotfundSuccess(resultTopBottom.data));
    }
  } catch (error) {
    yield put(fetchHotfundFailure(error.message));
  }
}

export function* fetchHotfundStart() {
  yield takeLatest(hotfundConstants.FETCH_HOTFUND_START, fetchHotfundAsync);
}

export function* hotfundSagas() {
  yield all([
    call(fetchHotfundStart),
  ]);
}
